module.exports = __webpack_public_path__ + "static/img/ent-detail-25.67286a2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-25.jpg
// module id = rZPj
// module chunks = 51